export const BACKEND_URL = import.meta.env.VITE_APP_SURVEY_BACKEND_URL || "http://localhost:8080";
export const REQUEST_TIMEOUT_MS = import.meta.env.VITE_APP_API_REQUEST_TIMEOUT_MS || 10000;